import { Header, AMPHeaderAndSideBar } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import React from 'react';
import { getPrimaryHeader } from '../../store/primaryHeader/primaryHeader.selectors';
import { getSecondaryHeader } from '../../store/secondaryHeader/secondaryHeader.selectors';


export const HeaderConnected: React.FunctionComponent = props => {
  const primaryHeader = useSelector(getPrimaryHeader);
  const secondaryHeader = useSelector(getSecondaryHeader);
  return <Header {...{ primaryHeader, secondaryHeader }} />;
};

export const AMPHeaderConnected: React.FunctionComponent = props => {
  const primaryHeader = useSelector(getPrimaryHeader);
  const secondaryHeader = useSelector(getSecondaryHeader);
  return <AMPHeaderAndSideBar {...{ primaryHeader, secondaryHeader }} />;
};
